module.exports = __webpack_public_path__ + "static/media/T&C_BrokeragePlan.37407067.pdf";